import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Detection Development</p>
        <p className="chapter__paragraph">
          Deepfake videos are created with machine-learning techniques, specifically when artificial
          intelligence is programmed to swap a person’s likeness. So to detect deepfakes,
          researchers start with data.
        </p>

        <p className="chapter__paragraph">
          Dr. Demir says that deepfake detection started with feeding data sets (thousands of real
          and fake videos) to the detector program, expecting it to discern real from fake. “If we
          only train the detector with those then they actually just find out whether it is created
          with the neural network of the specific dataset,” Dr. Demir says, instead of finding
          whether the video is of an actual human. So researchers changed their approach. “We are
          not trying to look for artifacts of fakery,” she adds, “But we are trying to find what
          makes us authentic.”
        </p>
      </section>
    </>
  );
}

export default Chapter4;
